import Header from './components/Header';
import Hero from './components/Hero';
import Topics from './components/Topics';
import Carousel from './components/Carousel';
import Features from './components/Features';
import Updates from './components/Updates';
import Ranking from './components/Ranking';
import Contact from './components/Contact';
import FAQ from './components/FAQ';
import Cards from './components/Cards';
import Comments from './components/Comments';
import AppEntry from './components/AppEntry';
import Index from './components/Index';
import Media from './components/Media';
import About from './components/About';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Topics />
        <Carousel />
        <Features />
        <Updates />
        <Ranking />
        <Contact />
        <FAQ />
        <Cards />
        <Comments />
        <AppEntry />
        <Index />
        <Media />
        <About />
      </main>
      <Footer />
    </>
  );
}